/** 多选的表格名称 */
export const tableNameConstant = {
  /** 失业登记:职业(工种)资格 */
  FJOBLEVEL: 'FJobLevel',
  /** 失业登记:专业技术职务 */
  FPROTECH: 'FProTech',
  /** 失业登记:求职意向 */
  FJOBINTENT: 'FJobIntent',
  /** 我要就业:求职意向 */
  FOBJECTIVE: 'FOBJECTIVE',
  /** 我要就业:工作经历 */
  FWORKEXPER: 'FWORKEXPER',
  /** 我要就业:教育经历 */
  FEDUEXPER: 'FEDUEXPER',
  /** 我要就业:证书 */
  FCERTIFICATE: 'FCERTIFICATE',
}